(() => {
  const root = window.NashTheme?.root || window.Shopify?.routes?.root || '/';
  const locale = (window.NashTheme?.locale || document.documentElement.lang || 'fr').slice(0, 2);
  const money = new Intl.NumberFormat(locale === 'uk' ? 'uk-UA' : locale === 'ru' ? 'ru-RU' : 'fr-FR', { style: 'currency', currency: 'EUR' });
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, ' ').replace(/[^a-z0-9а-яёіїєґ]+/gi, ' ').trim();
  const uiText = {
    added: locale === 'ru' ? 'Добавлено в корзину' : locale === 'uk' ? 'Додано до кошика' : 'Ajouté au panier',
    all: locale === 'ru' ? 'Все результаты' : locale === 'uk' ? 'Усі результати' : 'Voir tous les résultats',
    unavailable: locale === 'ru' ? 'Нет в наличии' : locale === 'uk' ? 'Немає в наявності' : 'Épuisé',
    stockLimit: locale === 'ru' ? 'Добавлено только доступное количество' : locale === 'uk' ? 'Додано лише доступну кількість' : 'Seule la quantité disponible a été ajoutée',
    maximumReached: locale === 'ru' ? 'Достигнут доступный остаток' : locale === 'uk' ? 'Досягнуто доступний залишок' : 'Stock maximum atteint',
    cartError: locale === 'ru' ? 'Корзина сохранена. Не удалось изменить этот товар.' : locale === 'uk' ? 'Кошик збережено. Не вдалося змінити цей товар.' : 'Votre panier est conservé. Impossible de modifier cet article.',
    addError: locale === 'ru' ? 'Не удалось добавить товар' : locale === 'uk' ? 'Не вдалося додати товар' : 'Impossible d’ajouter cet article'
  };

  const menuButtons = [...document.querySelectorAll('.mobile-menu-button')];
  const menu = document.getElementById('MobileMenu');
  const menuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');
  const closeMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    if (menuBackdrop) menuBackdrop.hidden = true;
    menuButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('menu-open');
  };
  const openMenu = () => {
    if (!menu) return;
    menu.hidden = false;
    if (menuBackdrop) menuBackdrop.hidden = false;
    menuButtons.forEach(button => button.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('menu-open');
    menu.querySelector('a,button')?.focus();
  };
  menuButtons.forEach(button => button.addEventListener('click', () => button.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu()));
  menu?.querySelector('.mobile-menu-close')?.addEventListener('click', closeMenu);
  menuBackdrop?.addEventListener('click', closeMenu);
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));

  const searchToggles = [...document.querySelectorAll('.search-toggle')];
  const searchPanel = document.getElementById('HeaderSearchPanel');
  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    searchToggles.forEach(button => button.setAttribute('aria-expanded', 'false'));
  };
  searchToggles.forEach(button => button.addEventListener('click', () => {
    if (!searchPanel) return;
    const willOpen = searchPanel.hidden;
    searchPanel.hidden = !willOpen;
    searchToggles.forEach(toggle => toggle.setAttribute('aria-expanded', String(willOpen)));
    if (willOpen) { closeMenu(); searchPanel.querySelector('input[type="search"]')?.focus(); }
  }));

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    closeMenu();
    closeSearch();
    document.querySelectorAll('[data-mega-menu][open]').forEach(item => item.removeAttribute('open'));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-mega-menu][open]').forEach(item => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-predictive-search]').forEach(wrapper => {
    const input = wrapper.querySelector('input[type="search"]');
    const results = wrapper.querySelector('.predictive-search');
    if (!input || !results) return;
    let timer;
    let controller;
    const mappedQuery = query => normalize(query).split(/\s+/).map(token => window.NM_SEARCH_SYNONYMS?.[token] || token).join(' ');
    const closeResults = () => { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); };
    const productTitle = product => {
      const handle = (product.url || '').split('/products/')[1]?.split(/[?#]/)[0] || product.handle || '';
      return window.NM_PRODUCT_TITLES?.[locale]?.[handle] || product.title;
    };
    const fetchSuggestions = async query => {
      if (controller) controller.abort();
      controller = new AbortController();
      const mapped = mappedQuery(query);
      const queries = [...new Set([query, mapped].filter(Boolean))];
      const calls = queries.map(term => fetch(`${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag`, { signal: controller.signal }).then(response => {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      }));
      const payloads = await Promise.all(calls);
      const seen = new Set();
      return payloads.flatMap(payload => payload.resources?.results?.products || []).filter(product => {
        if (seen.has(product.url)) return false;
        seen.add(product.url);
        return true;
      });
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) return closeResults();
      timer = setTimeout(async () => {
        try {
          const products = await fetchSuggestions(query);
          results.innerHTML = products.length ? products.slice(0, 10).map(product => `<a class="predictive-product" href="${escapeHtml(product.url)}"><span class="predictive-product__image">${product.image ? `<img src="${escapeHtml(product.image)}" alt="">` : ''}</span><span class="predictive-product__text"><strong>${escapeHtml(productTitle(product))}</strong><small>${escapeHtml(product.vendor || '')}</small></span><span class="predictive-product__price">${money.format(Number(product.price || 0))}</span></a>`).join('') + `<a class="predictive-view-all" href="${root}search?q=${encodeURIComponent(mappedQuery(query) || query)}&type=product">${uiText.all}</a>` : `<div class="predictive-empty">${escapeHtml(input.dataset.noResults || '')}</div>`;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') closeResults();
        }
      }, 150);
    });
    document.addEventListener('click', event => { if (!wrapper.contains(event.target)) closeResults(); });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach(selector => {
    const input = selector.querySelector('input');
    const clamp = value => Math.max(Number(input.min || 1), input.max ? Math.min(Number(input.max), value) : value);
    selector.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { input.value = clamp(Number(input.value || 1) - 1); });
    selector.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { const next = Number(input.value || 1) + 1; input.value = clamp(next); if (input.max && next > Number(input.max)) showToast(uiText.maximumReached); });
    input?.addEventListener('change', () => { const requested = Number(input.value || 1); input.value = clamp(requested); if (Number(input.value) !== requested) showToast(uiText.maximumReached); });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const main = gallery.querySelector('#ProductMainImage');
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(thumbnail => thumbnail.addEventListener('click', () => {
      if (!main) return;
      main.src = thumbnail.dataset.gallerySrc;
      main.removeAttribute('srcset');
      main.alt = thumbnail.dataset.galleryAlt || '';
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(item => item.classList.toggle('is-active', item === thumbnail));
    }));
  });

  const zoomButton = document.querySelector('[data-product-zoom]');
  const zoomDialog = document.querySelector('[data-product-zoom-dialog]');
  zoomButton?.addEventListener('click', () => {
    const source = document.getElementById('ProductMainImage');
    const target = zoomDialog?.querySelector('img');
    if (!source || !target || typeof zoomDialog.showModal !== 'function') return;
    target.src = source.currentSrc || source.src;
    target.alt = source.alt;
    zoomDialog.showModal();
  });
  zoomDialog?.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
  zoomDialog?.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });

  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const section = select.closest('[data-product-section]');
    const form = select.closest('[data-product-form]');
    const button = section?.querySelector('.product-add-button');
    const price = section?.querySelector('[data-product-price] > strong');
    const quantity = form?.querySelector('input[name="quantity"]');
    const stockStatus = section?.querySelector('[data-stock-status]');
    const stockLabel = stockStatus?.querySelector('[data-stock-label]');
    const available = option?.dataset.available === 'true';
    const limited = option?.dataset.inventoryLimited === 'true';
    const maximum = Math.max(0, Number(option?.dataset.inventoryMax || 0));
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (form) { form.dataset.inventoryLimited = String(limited); form.dataset.inventoryMax = String(maximum); }
    if (quantity) { if (limited) quantity.max = String(maximum); else quantity.removeAttribute('max'); quantity.value = Math.max(1, Math.min(Number(quantity.value || 1), maximum || 1)); }
    if (stockLabel) stockLabel.textContent = available && limited ? (stockStatus.dataset.stockCountTemplate || '').replace('__COUNT__', maximum) : available ? stockLabel.dataset.inStock || '' : uiText.unavailable;
    stockStatus?.classList.toggle('stock-status--out', !available);
    if (button) { button.disabled = !available; button.textContent = available ? button.dataset.addLabel || button.textContent : uiText.unavailable; }
  }));

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  filterToggle?.addEventListener('click', () => {
    const open = filterToggle.getAttribute('aria-expanded') === 'true';
    filterToggle.setAttribute('aria-expanded', String(!open));
    filterPanel?.classList.toggle('is-open', !open);
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(section => {
    if (section.innerHTML.trim() || !section.dataset.url) return;
    fetch(section.dataset.url).then(response => response.text()).then(text => {
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  });

  const toast = document.createElement('div');
  toast.className = 'nm-cart-toast';
  toast.setAttribute('role', 'status');
  document.body.appendChild(toast);
  let toastTimer;
  const showToast = text => {
    toast.textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 1800);
  };
  const updateCartCount = cart => document.querySelectorAll('.cart-count').forEach(count => { count.textContent = cart.item_count; });
  const animateToCart = source => {
    const target = document.querySelector('.cart-link') || document.querySelector('.mobile-bottom-cart');
    if (!source || !target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const from = source.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    const flyer = source.cloneNode(true);
    flyer.className = 'nm-fly-to-cart';
    Object.assign(flyer.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${Math.min(from.width, 110)}px`, height: `${Math.min(from.height, 110)}px` });
    document.body.appendChild(flyer);
    requestAnimationFrame(() => {
      flyer.style.transform = `translate(${to.left + to.width / 2 - from.left - Math.min(from.width, 110) / 2}px, ${to.top + to.height / 2 - from.top - Math.min(from.height, 110) / 2}px) scale(.18)`;
      flyer.style.opacity = '0.2';
    });
    flyer.addEventListener('transitionend', () => flyer.remove(), { once: true });
    setTimeout(() => flyer.remove(), 900);
  };

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-quick-add], [data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button?.classList.contains('is-loading')) return;
    button?.classList.add('is-loading');
    try {
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      let requested = Math.max(1, Number(formData.get('quantity') || 1));
      let adjusted = false;
      if (form.dataset.inventoryLimited === 'true') {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(uiText.addError);
        const cart = await cartResponse.json();
        const existing = cart.items.filter(item => Number(item.variant_id) === variantId).reduce((sum, item) => sum + item.quantity, 0);
        const remaining = Math.max(0, Number(form.dataset.inventoryMax || 0) - existing);
        if (remaining < 1) { showToast(uiText.maximumReached); return; }
        if (requested > remaining) { requested = remaining; adjusted = true; }
      }
      formData.set('quantity', String(requested));
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      if (!response.ok) { const payload = await response.json().catch(() => ({})); throw new Error(payload.description || uiText.addError); }
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(uiText.addError);
      const cart = await cartResponse.json();
      updateCartCount(cart);
      animateToCart(form.closest('.product-card')?.querySelector('.product-card__image img') || document.getElementById('ProductMainImage'));
      showToast(adjusted ? uiText.stockLimit : uiText.added);
    } catch (error) {
      showToast(error.message || uiText.addError);
    } finally {
      button?.classList.remove('is-loading');
    }
  });

  const changeCartLine = async (key, quantity, input) => {
    const previous = Number(input?.dataset.previousQuantity || input?.value || 0);
    const maximum = input?.max ? Number(input.max) : Infinity;
    const requested = Math.max(0, Number(quantity || 0));
    const safeQuantity = Math.min(maximum, requested);
    if (requested > maximum) showToast(uiText.stockLimit);
    input?.closest('[data-cart-quantity-selector]')?.classList.add('is-loading');
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: safeQuantity }) });
      if (!response.ok) throw new Error('Cart change failed');
      const cart = await response.json();
      updateCartCount(cart);
      window.location.reload();
    } catch (error) {
      if (input) input.value = previous;
      showToast(uiText.cartError);
    } finally {
      input?.closest('[data-cart-quantity-selector]')?.classList.remove('is-loading');
    }
  };

  document.querySelectorAll('[data-cart-quantity-selector]').forEach(selector => {
    const input = selector.querySelector('[data-cart-quantity]');
    if (!input) return;
    selector.querySelector('[data-cart-minus]')?.addEventListener('click', () => changeCartLine(input.dataset.cartKey, Number(input.value || 0) - 1, input));
    selector.querySelector('[data-cart-plus]')?.addEventListener('click', () => {
      const next = Number(input.value || 0) + 1;
      if (input.max && next > Number(input.max)) { input.value = input.max; showToast(uiText.maximumReached); return; }
      changeCartLine(input.dataset.cartKey, next, input);
    });
    input.addEventListener('change', () => changeCartLine(input.dataset.cartKey, input.value, input));
  });
  document.querySelectorAll('[data-cart-remove]').forEach(button => button.addEventListener('click', () => {
    const input = button.closest('[data-cart-item]')?.querySelector('[data-cart-quantity]');
    changeCartLine(button.dataset.cartKey, 0, input);
  }));
})();
